import h from 'hyperscript';
import getVideoId from 'get-video-id';

class Figure {
  constructor($el) {
    // Elements
    this.$el = $el;
    this.$media = this.$el.querySelector('.privacy-layer__media');
    this.$videoPlay = this.$el.querySelector('.privacy-layer__play-button');
    this.$vimeoPlay = this.$el.querySelector('.privacy-layer__vimeo-button');
    this.getCookie();

    // Add events Vimeo
    if (this.$vimeoPlay) {
      this.$vimeoPlay.addEventListener('click', () => {
        this.Setcookie('cookie-external-vimeo');
        this.onVimeoClick.bind(this);
      });
      this.$vimeoPlay.addEventListener('click', this.onVimeoClick.bind(this));
    }

    // Add events
    if (this.$videoPlay) {
      this.$videoPlay.addEventListener('click', () => {
        this.Setcookie('cookie-external-youtube');
        this.onVideoClick.bind(this);
      });
      this.$videoPlay.addEventListener('click', this.onVideoClick.bind(this));
    }
  }

  getCookie() {
    const videoCookie = 'video';
    const vimeoCookie = 'flockler';
    let videoName = '';
    let vimeoName = '';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf('cookie-external-youtube') === 0) {
        videoName = c.substring(videoCookie.length, c.length);
      }
      if (c.indexOf('cookie-external-vimeo') === 0) {
        vimeoName = c.substring(vimeoCookie.length, c.length);
      }
    }
    if (this.$videoPlay) {
      if (videoName) {
        this.onVideoClick();
      }
    }
    if (this.$vimeoPlay) {
      if (vimeoName) {
        this.onVimeoClick();
      }
    }
  }

  Setcookie(cname) {
    const days = 30;
    const myDate = new Date();
    myDate.setTime(myDate.getTime() + (days * 24 * 60 * 60 * 1000));

    if (this.$videoPlay || this.$vimeoPlay) {
      document.cookie = cname + '=allow'.concat(';expires=').concat(myDate.toGMTString(), ';path=/');
    }
  }

  onVideoClick(event) {
    const { id, service } = getVideoId(this.$videoPlay.href);

    this.$el.classList.add('privacy-layer__overlay-hidden');

    if (event) {
      event.preventDefault();
    }

    if (id && service === 'youtube') {
      // Construct Youtube iframe player, add rel=0 to disable related videos
      const $iframe = h(
        '.privacy-layer__video-wrapper',
        h('iframe.privacy-layer__video', {
          src: `https://www.youtube-nocookie.com/embed/${id}?rel=0&autoplay=0`,
          allowFullscreen: true,
          msAllowFullscreen: true,
          webkitAllowFullscreen: true,
          mozAllowFullscreen: true,
        }),
      );

      // Replace with iframe
      this.$videoPlay.parentNode.replaceChild($iframe, this.$videoPlay);
    }
  }

  onVimeoClick(event) {
    const { id, service } = getVideoId(this.$vimeoPlay.href);

    this.$el.classList.add('privacy-layer__overlay-hidden');

    if (event) {
      event.preventDefault();
    }

    if (id && service === 'vimeo') {
      // Construct Youtube iframe player, add rel=0 to disable related videos
      const $iframe = h(
        '.privacy-layer__video-wrapper',
        h('iframe.privacy-layer__video', {
          src: `https://player.vimeo.com/video/${id}?autoplay=0&loop=0`,
          allowFullscreen: true,
          msAllowFullscreen: true,
          webkitAllowFullscreen: true,
          mozAllowFullscreen: true,
          allow: 'autoplay',
        }),
      );

      // Replace with iframe
      this.$vimeoPlay.parentNode.replaceChild($iframe, this.$vimeoPlay);
    }
  }
}

document.querySelectorAll('.js-privacy-layer').forEach($el => new Figure($el));
